<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>

</style>

<body class="sb-nav-fixed">
  <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
      <!-- Navbar Brand-->
      <a class="navbar-brand ps-3" href="http://support.qcell.kr/">QCELL</a>
      <!-- Sidebar Toggle-->
      <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" href="#!"><i class="fas fa-bars"></i></button>

      <!-- Navbar-->
      <div class="container-fluid">
          <a class="navbar-brand"></a>

          <ul class="navbar-nav">

                <li class="nav-item">
                    <a class="nav-link" aria-current="page" href="https://righttech.co.kr/">홈페이지</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" aria-current="page" href="http://support.qcell.kr/">QCELL Home</a>
                </li>
				<li class="nav-item">
                  <a class="nav-link" href="http://support.qcell.kr/api_doc/index.html">API 문서</a>
				</li>

          </ul>
      </div>
  </nav>
  <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
          <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
              <div class="sb-sidenav-menu">
                  <div class="nav">

                      <div class="sb-sidenav-menu-heading">목록</div>
                      <!--사이드바 주제목-->  <!--.sb-sidenav-dark .sb-sidenav-menu .nav-link  => style.css 파일에서 해당 이름의 스타일들은 사이드바의 글자 색깔을 나타내며 변경 시 수정하면 됨-->
                  
                          <nav class="sb-sidenav-menu-nested nav">
                              
                            <a class="nav-link"  href="http://support.qcell.kr:5000/"><img src="/assets/reactlogo.png" style="width:15px; height:15px;">&nbsp; React</a>
                            <a class="nav-link" href="http://support.qcell.kr:3500/"> <img src="/assets/vuelogo.png" style="width:15px; height:15px;">&nbsp; Vue</a>
                            <a class="nav-link" href="http://support.qcell.kr:4000/"><img src="/assets/angularlogo.png" style="width:15px; height:15px;">&nbsp; Angular</a>
           
                          </nav>
                  </div>
              </div>
              <div class="sb-sidenav-footer">
                  <div class="small">GRID</div>
                  QCELL
              </div>
          </nav>

      </div>
      <div id="layoutSidenav_content">
          <article class="page">
              <!--set-content{max-width:calc(100% - 210px)}내용 간격 조정-->
          
<div class="content" role="main">
  <div class="container-fluid">
    <div class="row">
      <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
        <div class="sidebar-sticky pt-3">
          <ul class="nav flex-column">
            <li class="nav-item">
              <a id="a001" class="nav-link active" onclick='menuClick("001")' style="cursor:pointer">
                <span data-feather="home"></span>
                First QCELL
              </a>
            </li>
            <li class="nav-item">
              <a id="a002"  class="nav-link" onclick='menuClick("002")' style="cursor:pointer">
                <span data-feather="file"></span>
                String Format
              </a>
            </li>
            <li class="nav-item">
              <a id="a003"  class="nav-link" onclick='menuClick("003")' style="cursor:pointer">
                <span data-feather="shopping-cart"></span>
                Number Format
              </a>
            </li>
            <li class="nav-item">
              <a id="a004"  class="nav-link" onclick='menuClick("004")' style="cursor:pointer">
                <span data-feather="users"></span>
                Column Type
              </a>
            </li>
            <li class="nav-item">
              <a id="a005"  class="nav-link" onclick='menuClick("005")' style="cursor:pointer">
                <span data-feather="bar-chart-2"></span>
                Master Detail
              </a>
            </li>
  
          </ul>
  
          
        </div>
      </nav>
  
      <div role="main" class="col-md-9 ml-sm-auto col-lg-10 px-md-4">
        <br><br>
        <div id="div1">
          <div class="">
            <p>1. QCELL 을 로딩하기 위한 qcell.js 를 링크 한다.<br>
              2. declare var QCELL: any; 를 이용하여 qcell 을 사용하기 위한 type script 파일에서 선언을 한다.<br>
              3. QCELL.create 와 같이 QCELL 에 정의 된 API 를 통해서 QCELL 을 생성 한다.
            </p>
          </div>
            <br>
          <div id="sheetarea1" style="width:100%;height:90px;"></div><br>
          <h2 id="about-column-hiding2">앵귤러 (Angular)</h2>
          <img src="/assets/angular2logo.png" style="width: 200px; height: 100px"> <br>   <br>
           <p>프로젝트를 시작하여 최적화 과정까지 많은 작업에서 사용 가능한 프레임워크이기에 개발 과정에 있어 리액트, 뷰와 비교하여 다루기 힘든 프레임워크입니다.<br>하지만 선택하여 다양하게 사용할 수 있는 기능들이 있기에 개발자들은 어떠한 호스트(host)앱이라 하더라도 간단한 명령만으로 최적화된 번들(bundle)앱을 만들 수 있습니다.</p>
            <br> <h3 id="step-2-column-hiding">앵귤러를 선호하는 경우</h3>
            * SNS 앱과 같이 실시간 앱을 개발할 때<br>
            * 신뢰를 바탕으로 확장이 가능한 프레임워크를 선택할 때<br>
            * 장기 프로젝트나 규모가 큰 네이티브 앱, 하이브리드 앱, 또는 웹 앱을 개발할 때 <br>
            * 타입스크립트(TypeScript)로 코딩하거나 객제지향 프로그래밍을 해야할 때<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
            

        </div>
        <div id="div2">
          <div class="">
            <p> 일반적인 String Format은 String Data에 앞이나 뒤에 수식어를 붙이는 정도의 활용이 가능하지만,
              Custom Format은 예제와 같이 전화번호 / 주민번호 / 사업자 번호 / 카드번호 / 우편번호 등 사용하고자 하는 Format에 대한 설정을 사용자가 직접 결정할 수 있습니다.
            </p>
          </div>
            <br>          
          <div id="sheetarea2" style="width:100%;height:600px;"></div>
        </div>
        <div id="div3">
          <div class="">
            <p> Number Format을 활용하는 예제입니다.
              Number Data를 String Format과 같이 앞 / 뒤에 원하는 수식어를 붙여 표현할 수 있으며, 숫자의 1000단위 구분기호(,)와 같은 자릿수와 소수점(.) 기호에 대한 표현 방식을 지원하는 국가의 Format에 맞춰 표현하여 사용할 수 있습니다.
            </p>
          </div>
            <br>            
          <div id="sheetarea3" style="width:100%;height:600px;"></div>
        </div>
        <div id="div4">
          <div class="">
            <p> QCELL에서 지원하는 여러 타입들을 활용하는 예제입니다.
              ① 출력만을 지원하는 "static", ② 일반적인 입력형태인 "input", ③ 장문의 입력형태의 "textarea", ④ checkbox와 radio 기능을 지원하는 "checkbox", ⑤ combo를 지원하는 "selectmenu", ⑥ cell안에 html tag의 사용을 지원하는 "html", ⑦ image를 지원하는 "image"를 통해 사용자가 원하는 형태로의 데이터 표현이 가능합니다.
            </p>            
          </div>
          <br>          
          <div id="sheetarea4" style="width:100%;height:600px;"></div>
        </div>
        <div id="div5">
          <div class="">
            <p> QCELL 은 업무 화면에 여러개의 그리드를 표현하여 다양한 정보를 표현 할 수 있습니다.
            </p>            
          </div>
          <br>          
          <div id="sheetmaster" style="width:100%;height:300px;"></div><br/>
          <div id="sheetdetail" style="width:100%;height:300px;"></div>
        </div>                        
      </div>
    </div>
  </div>


</div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<router-outlet></router-outlet>

</article>
<footer class="py-4 bg-light mt-auto">
    <div class="container-fluid px-4" >
        <div class="d-flex align-items-center justify-content-between small">
            <div class="text-muted">&copy;COPYRIGHT RIGHT TECH INC. © 2017. ALL RIGHTS RESERVED.</div>
        </div>
    </div>
</footer>


</div>


</div>

</body>